import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const TrackURed = ({ state, workState, onLabelClick }) => (
	<g id="TrackURed" transform="translate(1933.000000, 1333.000000)" className="track">
		<g id="line" transform="translate(0.000421, 0.722106)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M144,85.6045477 C126.676524,92.6176677 106.897263,89.5028117 92.5676555,77.5049353 L30.7806222,25.7719623 L30.7806222,25.7719623"/>
			<line x1="21.7863578" y1="18.2412554" x2="7.63833441e-14" y2="3.14682308e-13"/>

			<TrackArrow
				transform="translate(19.947458, 17.003024) rotate(-141.000000) translate(-19.947458, -17.003024) "
				points="23.9474575 25.0030241 15.9474575 17.0030241 23.9474575 9.00302414"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'TrackURed')}
			coords="48.000000, 38.000000"
			text="U"
			textCoordsX="13.7011719"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>

);

TrackURed.propTypes = trackPropTypes;

export default TrackURed;
